export default __webpack_public_path__ + "static/media/sentiment_unhappy.aaa3a75d.svg";